import { useTenantContext } from "providers/TenantProvider/TenantProvider";
import { Helmet } from "react-helmet-async";
import { useUserContext } from "providers/UserProvider/UserProvider";
import { PageOrganizationDashboard } from "./PageOrganizationDashboard";
import { PageOrganizationExternalDashboard } from "./PageOrganizationExternalDashboard";
import {
  useSetCurrentPage,
  useSetTourCondition,
} from "providers/TourProvider/TourProvider.hooks";
import { TenantType } from "types/constants";

export const PageOrganization = () => {
  const currentTenant = useTenantContext((s) => s.currentTenant);
  const { currentUserTenants, personalSpace } = useUserContext((s) => ({
    currentUserTenants: s.tenants,
    personalSpace: s.personalSpace,
  }));
  const isPersonalSpace = currentTenant.tenantType === TenantType.PERSONAL;

  const isOrgAdmin = isPersonalSpace
    ? personalSpace?.role.key === "admin"
    : currentUserTenants.find((tenant) => tenant.key === currentTenant.key)
        ?.role.key === "admin";
  useSetCurrentPage("organizationProjects");
  useSetTourCondition("isOrgAdmin", isOrgAdmin);
  useSetTourCondition(
    "isPersonalSpace",
    currentTenant.tenantType === TenantType.PERSONAL,
  );

  const userIsTenantMember =
    currentUserTenants.some(({ id }) => id === currentTenant.id) ||
    currentTenant.id === personalSpace?.id;

  return (
    <>
      <Helmet>
        <title>{currentTenant.name}</title>
      </Helmet>
      {userIsTenantMember ? (
        <PageOrganizationDashboard />
      ) : (
        <PageOrganizationExternalDashboard />
      )}
    </>
  );
};
